// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { FormItem, IFormInstance } from '@/components';
import { Button, Select } from '@/ui';
import { StyledForm, StyledRow } from './LLMConfigFormStyles';

// Helpers
import { TLLMConfigFormValues, LLMConfigFormFields } from '../../helpers';

type TLLMConfigFormProps = {
  onSubmit: (values: TLLMConfigFormValues) => void;
  initialValues?: Partial<TLLMConfigFormValues>;
  isLoading?: boolean;
  showAttributes?: boolean;
  className?: string;
  form: IFormInstance;
};

const LLMConfigForm: FC<TLLMConfigFormProps> = ({
  onSubmit,
  initialValues,
  isLoading,
  form,
  showAttributes,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <StyledForm form={form} className={className} initialValues={initialValues} onFinish={onSubmit}>
      <StyledRow>
        <FormItem label={t('label_key_values')} name={LLMConfigFormFields.KEY_VALUES}>
          <Select dropdownStyle={{ display: 'none' }} mode="tags" suffixIcon={null} />
        </FormItem>
        {showAttributes && (
          <FormItem label={t('label_main_attributes')} name={LLMConfigFormFields.ATTRIBUTES}>
            <Select dropdownStyle={{ display: 'none' }} mode="tags" suffixIcon={null} />
          </FormItem>
        )}
      </StyledRow>
      <Button loading={isLoading} htmlType="submit" type="primary">
        {t('btn_save')}
      </Button>
    </StyledForm>
  );
};

export default LLMConfigForm;
